import type { ReactNode } from 'react'

export interface PackSectionHeaderProps {
  children: ReactNode
}

export function PackSectionHeader({ children }: PackSectionHeaderProps) {
  return (
    <li className="col-span-full text-lg md:text-2xl text-center font-bold uppercase tracking-wide text-neutral-900 dark:text-neutral-100">
      {children}
    </li>
  )
}
